import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CsvExporterService} from "./csv-exporter.service";

@NgModule({
    imports: [CommonModule],
    declarations: [],
    exports: []
})
export class CsvExporterModule {
    static forRoot(): ModuleWithProviders<CsvExporterModule> {
        return {
            ngModule: CsvExporterModule,
            providers: [CsvExporterService]
        }
    }
}
